import React from 'react';

export const ThumbsDown = () => <span className='added-players-list-row-wants-win-toggle-status'>&#128078;</span>;